const config = {
	title: 'Bitbns',
	author: {
		name: 'Bitns',
		summary:
			'Buy Bitcoin & Cryptocurrency in India | Bitcoin Exchange | Cryptocurrency Exchange',
	},
	description:
		'The fastest and easiest way to buy & sell Bitcoin (BTC) on Bitbns cryptocurrency exchange in India. Trade Cryptocurrencies in INR on Bitbns at a Lowest trading fee in India. Get Free Bitcoin in our Flash Sale.',
	social: {
		twitter: '@bitbns',
	},
};

export default config;
